import React from 'react';
import moment from 'moment-timezone';
import { getFormatTimeLeft } from '_helpers';

const SEC = 1000;

class DetailsTimeLeft extends React.Component<TimeLeftProps> {
    timeoutFunction: number = 0;
    updateClocksInterval: any = 0;

    constructor(props: TimeLeftProps) {
        super(props);
        const { duration, actualStartTime, timeoutFunc } = props;

        const durationInMs = 1000 * 60 * Number(duration);
        const elapsedTime = +moment() - (+actualStartTime);

        if (durationInMs && durationInMs - elapsedTime > 0 && timeoutFunc) {
            this.timeoutFunction = window.setTimeout(timeoutFunc, durationInMs - elapsedTime);
        } else if (durationInMs && durationInMs - elapsedTime <= 0 && timeoutFunc) {
            timeoutFunc();
        }

        this.updateClocksInterval = setInterval(this.forceUpdate.bind(this), SEC);
    }

    componentWillUnmount(): void {
        clearTimeout(this.timeoutFunction);
        clearInterval(this.updateClocksInterval);
    }

    render() {
        const { duration, actualStartTime } = this.props;
        const durationInMs = 1000 * 60 * Number(duration);
        const elapsedTime = +moment() - (+actualStartTime);
        const percents = Math.floor((1 - elapsedTime / durationInMs) * 100);

        const resultPercents = Number(Math.abs(percents) !== Infinity) && percents;
        return (
            <div>
                {getFormatTimeLeft(durationInMs - elapsedTime)} / {resultPercents}%
            </div>
        );
    }
}

interface TimeLeftProps {
    duration?: number;
    actualStartTime: moment.Moment;
    timeoutFunc?: () => void;
}


export default DetailsTimeLeft;
